import {
  Button,
  Col,
  RemovableCard,
  Row,
  TextAreaInputField,
  TextInputField,
} from '@/components';
import { useProjectFormContext } from '@/features/project/_hooks/form-context';
import { PlusOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  contentsHint?: string;
  urlHint?: string;
  autocompleteKey: string;
  gutter?: [number, number];
};

export const PlansArrayField: FC<Props> = ({
  contentsHint,
  urlHint,
  autocompleteKey,
  gutter = [24, 8],
}) => {
  const {
    control,
    formState: { errors },
  } = useProjectFormContext();
  const { t } = useTranslation();

  const {
    fields: planFields,
    append: appendPlan,
    remove: removePlan,
  } = useFieldArray({
    control,
    name: 'data.plans',
  });

  return (
    <Row gutter={[24, 8]}>
      {planFields.map((item, idx) => {
        return (
          <Col key={item.id} span={24}>
            <RemovableCard
              onRemove={() => {
                removePlan(idx);
              }}
            >
              <Row gutter={gutter} wrap={false}>
                <Col span={12}>
                  <TextAreaInputField
                    name={`data.plans.${idx}.contents`}
                    label={t('plan-content')}
                    hint={contentsHint}
                    control={control}
                    errors={errors}
                    rows={3}
                  />
                </Col>
                <Col span={12}>
                  <TextInputField
                    name={`data.plans.${idx}.url`}
                    autocompleteKey={autocompleteKey}
                    label={t('plan-url')}
                    hint={urlHint}
                    control={control}
                    errors={errors}
                  />
                </Col>
              </Row>
            </RemovableCard>
          </Col>
        );
      })}
      <Col span={12}>
        <Button
          type="dashed"
          onClick={() => {
            appendPlan({
              url: null,
              contents: null,
            });
          }}
          block
          icon={<PlusOutlined aria-label="" />}
        >
          {t('add-project-plan')}
        </Button>
      </Col>
    </Row>
  );
};
